// extracted by mini-css-extract-plugin
export default {"component":"graphic_component__T0b35","defaultBGColor":"graphic_defaultBGColor__EDeRF","icon":"graphic_icon__0XeuQ"};